export function setRem(designWidth = 750) {
  const docEl = document.documentElement;

  const dpr = window.top === window.self ? window.devicePixelRatio : 1;
  docEl.dataset.dpr = dpr;

  // 设置viewport，进行缩放，达到高清效果
  // const metaEl = document.querySelector('meta[name="viewport"]');
  // const scale = 1 / dpr;
  // metaEl.setAttribute(
  //   "content",
  //   "width=device-width" +
  //     ",initial-scale=" +
  //     scale +
  //     ",maximum-scale=" +
  //     scale +
  //     ", minimum-scale=" +
  //     scale +
  //     ",user-scalable=no, viewport-fit=cover, shrink-to-fit=no"
  // );

  let rem = 100; // max: 1rem = 100px
  const recalc = function () {
    // 修正页面高度100%的渲染错误
    docEl.style.height = window.innerHeight + "px";

    // const clientWidth = Math.min(docEl.clientWidth, designWidth);
    const clientWidth = docEl.clientWidth;
    docEl.dataset.width = clientWidth;
    docEl.dataset.layout = clientWidth > designWidth ? "pc" : "mobile";

    docEl.dataset.rem = rem = Math.min(
      100,
      Math.round(100 * (clientWidth / designWidth))
    );
    // 配合设置viewport，进行缩放，达到高清效果
    // docEl.dataset.rem = rem =
    //   Math.round(100 * (clientWidth / designWidth)) * dpr;
    docEl.style.fontSize = rem + "px";
  };

  recalc();

  // 供js调用的，某一dpr下rem和px之间的转换函数
  window.rem2px = function (v) {
    return parseFloat(v) * rem;
  };
  window.px2rem = function (v) {
    return parseFloat(v) / rem;
  };

  if (!window.addEventListener) {
    return;
  }
  window.addEventListener(
    "orientationchange" in window ? "orientationchange" : "resize",
    recalc,
    false
  );
}
